import 'core-js'
import { configureAndInstall } from './utils/raven'

// setup sentry logging
configureAndInstall()

// DO NOT USE IMPORT.  import will hoist this so it will be performed *before*
// the raven configuration, which will cause the Raven.config line above to be
// completely ignored.
require('./router')

const meta = document.createElement('meta')
meta.name = 'referrer'
meta.content = 'origin'
document.getElementsByTagName('head')[0].appendChild(meta)
